import { render } from "./LeftMenu.vue?vue&type=template&id=237edfbd&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=237edfbd&scoped=true&lang=css"

import exportComponent from "/opt/qyxs/qinyan_pro/qinyan_pro_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237edfbd"]])

export default __exports__